import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import "./BriefsDetailVisitor.css";
import AppLayout from "../../layouts/AppLayout.jsx";
import { fetchApiData } from "../../../store/slicers/apiSlicer.js";

const BriefsDetailVisitor = () => {
  const dispatch = useDispatch();
  const [briefs, setBriefs] = useState([]);

  const { data, isLoading } = useSelector((state) => ({
    data: state.apiData?.data?.briefsAll,
    isLoading: state.apiData?.loading?.briefsAll
  }));

  useEffect(() => {
    dispatch(fetchApiData({ url: 'briefs', itemKey: 'briefsAll' }));
  }, [dispatch]);

  useEffect(() => {
    if (data?.data) {
      setBriefs( data?.data?.data || [] );
    }
  }, [data]);

  const formatDate = (dateStr) => {
    if (!dateStr) return null;
    return new Date(dateStr).toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (isLoading) return <p className="loading">Chargement des brèves...</p>;

  return (
    <div className="briefs-grid-container">
      <h2 className="briefs-grid-header">
        <i className="pi pi-newspaper"></i> Toutes les Brèves
      </h2>

      {briefs.length === 0 && (
        <p className="no-briefs">Aucune brève disponible pour le moment.</p>
      )}

      <div className="briefs-grid">
        {briefs.map((brief) => (
          <div key={brief.id} className="brief-card">
            {/* Image */}
            {brief.image && (
              <div className="brief-image-container">
                <img src={brief.image} alt={brief.title} className="brief-image" />
              </div>
            )}

            {/* Contenu */}
            <div className="brief-info">
              <h3 className="brief-title">{brief.title}</h3>

              {brief.category && (
                <span className="brief-category">{brief.category}</span>
              )}

              {/* Date de l’événement ou de publication */}
              {brief.date && (
                <p className="brief-date">
                  <i className="pi pi-calendar"></i>{" "}
                  {formatDate(brief.date)}
                </p>
              )}

              {/* Date de création */}
              {brief.created_at && (
                <p className="brief-created">
                  <i className="pi pi-clock"></i>{" "}
                  Créée le : {formatDate(brief.created_at)}
                </p>
              )}

              {/* Auteur */}
              {brief.author && (
                <p className="brief-author">
                  <i className="pi pi-user"></i> {brief.author}
                </p>
              )}

              {/* Contenu */}
              <p className="brief-content">{brief.content}</p>

              {/* Source */}
              {brief.source && (
                <p className="brief-source">
                  Source :{" "}
                  <a
                    href={brief.source}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {brief.source}
                  </a>
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const BriefsDetail = () => {
  return <>
        <AppLayout>
          <BriefsDetailVisitor />
        </AppLayout>
      </>;
};

export default BriefsDetail;


